import axios from "@/plugins/axios";

let url = "/api/v1/message";

export default {
    post(data){
        return axios.post(url, data).then(result => result.data);
    },
}
